import Rails from "@rails/ujs"
import { Controller } from "stimulus"
import mdkController from "./mdk_controller"

export default class extends mdkController {
  static targets = ['form','notification'];
  static classes = ['errorm','hide'];
  static values = {validateurl: String};

  formTargetConnected() {
    this.control_show_and_hide();
    super.connect();
  }

  validate(event){
    const el = event.currentTarget;
    const pa = el.parentElement;
    const params = event.params;
    let errorM = pa.querySelector("."+this.errormClass);
    if(errorM == undefined){
      errorM = pa.parentElement.querySelector("."+this.errormClass);
      if(errorM == undefined){
        errorM = pa.parentElement.parentElement.querySelector("."+this.errormClass);
      }
    }
    this.control_show_and_hide();
    const formData = new FormData(this.formTarget);
    formData.append("type",params.column);
    Rails.ajax({
      url: this.validateurlValue,
      type: "POST",
      dataType: 'json',
      data: formData,
      success: (response)=> {
        errorM.innerHTML = response;
      }
    });
  }

  validateAll(event){
    const el = event.currentTarget;
    el.disabled = true;
    let errorMs = document.querySelectorAll("."+this.errormClass);
    errorMs.forEach(function (m) {
      m.textContent = "";
    });
    const formData = new FormData(this.formTarget);
    const allErrorE = document.getElementById("allError");
    Rails.ajax({
      url: this.validateurlValue,
      type: "POST",
      dataType: 'json',
      data: formData,
      success: (response)=> {
        if(response != null && Object.keys(response).length > 0){
          let allErrorTxt = "";
          Object.keys(response).forEach(function (key) {
            errorMs.forEach(function (m) {
              if (m.dataset.errormtarget == key){
                m.innerHTML = response[key];
                allErrorTxt += response[key]+"<br />";
              }
            })
          });
          allErrorE.innerHTML = allErrorTxt;
          allErrorE.classList.remove(this.hideClass);
          el.disabled = false;
        }else{
          const card_info_input = this.formTarget.querySelector("#card_info_input_field");
          const formTarget = this.formTarget
          const payment_method_conveni = this.formTarget.querySelector("#reservation_payment_method_conveni");
          let conveni_flag = false;
          if(payment_method_conveni != null){
            if(payment_method_conveni.checked){
              conveni_flag = true;
            }
          }
          if(card_info_input != null && conveni_flag == false){
            this.register(()=>{
              allErrorE.innerHTML = '';
              allErrorE.classList.add(this.hideClass);
              formTarget.submit();
            },()=>{
              el.disabled = false;
            });
          }else{
            allErrorE.innerHTML = '';
            allErrorE.classList.add(this.hideClass);
            formTarget.submit();
          }
        }
      }
    });
  }

  onSubmit(event){
    this.formTarget.submit();
  }

  control_show_and_hide(){

    //支払関連の表示・非表示
    const credit = this.formTarget.querySelector("#reservation_payment_method_credit")
    const invoice = this.formTarget.querySelector("#reservation_payment_method_conveni")
    const card_info = this.formTarget.querySelector("#card_info")
    const invoice_address = this.formTarget.querySelector("#invoice_address_input_field")
    const conveni_notice = this.formTarget.querySelector("#coiveniNotice")
    if(credit != null && card_info != null){
      if(credit.checked){
        card_info.hidden = false;
      }else{
        card_info.hidden = true;
      }
    }
    //コンビニ支払のラジオボタンが存在している場合
    if(invoice != null && invoice_address != null){
      if(invoice.checked){
        invoice_address.hidden = false
        conveni_notice.hidden = false;
      }else{
        invoice_address.hidden = true
        conveni_notice.hidden = true;
      }
    }
  }

}
